/** @module Camunda/TaskStateRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/locale",
	"csi/widget/CustomIconWithLabel",
	"csi/widget/MaterialIconWithLabel",
	"./main"
], function (declare, Enum, locale, CustomIconWithLabel, MaterialIconWithLabel, Camunda) {

	const STATE_HASISSUES = "CamundaStateHasIssues";

	return declare(Enum, {
		/**
		 * @override
		 * Render icon and text
		 */
		toHtmlStatic: function (ctx, h, refNode, actionData) {
			const node = ctx.getNode();
			const hasIssues = node.HasIssues;
			let state = node.ActivityState;

			if (hasIssues && (state == Camunda.STATE_STARTED)) {
				state = STATE_HASISSUES;
			}

			const label = locale.capitalizeResource(state);

			switch (state) {
				case Camunda.STATE_STARTED:
					new CustomIconWithLabel({
						icon: "process",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_COMPLETED:
					new MaterialIconWithLabel({
						icon: "check_circle",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_CANCELLED:
					new MaterialIconWithLabel({
						icon: "cancel",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_SUSPENDED:
					new MaterialIconWithLabel({
						icon: "pause_circle",
						label: label
					}).placeAt(refNode);
					break;
				case Camunda.STATE_ERROR:
					new MaterialIconWithLabel({
						icon: "cancel",
						iconCss: "csi-camunda-state-error",
						label: label
					}).placeAt(refNode);
					break;
				case STATE_HASISSUES:
					new MaterialIconWithLabel({
						icon: "error",
						label: label
					}).placeAt(refNode);
					break;
			}

			return true;
		}
	});
});